// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__1ZbAD","clinicsSelect":"TableHeading_clinicsSelect__22n1H"};